module fdm.layout.nav {

    export class MainNavController {
        public links: any;
        public currentUser: dg.modules.users.IUser;
        public pilotPerformanceLinks: dg.restfulApi.Link[];
        public statisticsLinks: dg.restfulApi.Link[];
        public adminLinks: dg.restfulApi.Link[];
        public managementLinks: dg.restfulApi.Link[];

        $onChanges(changes) {

            if (changes.links && changes.links.currentValue) {
                this.pilotPerformanceLinks = [this.links.pilots, this.links.performedLegs, this.links.pilotOverview];
                this.statisticsLinks = [this.links.overview, this.links.yearToDate, this.links.analysedLegs, this.links.analysedEvents, this.links.ECMData];
                this.adminLinks = [this.links.users, this.links.roles, this.links.airports];
                this.managementLinks = [this.links.aircraftLayout, this.links.aircraftTypeLayout, this.links.aircraftFamilyLayout,
                    this.links.engineTypeLayout, 
                    {
                        "id": "clientManagement",
                        "title": "Client Management",
                        "rel": "urn:org.digmo:rels/query",
                        "href": "/api/v1/client",
                        "urnTemplate": "/client",
                        "parameters": {},
                        "method": "GET",
                        "mediaType": "text/json",
                        "disabledReason": this.links.clientManagement.disabledReason
                    }];
            }
        }
    }

    angular.module('fdm')
        .component('mainNav', {
            bindings: {
                links: '<',
                currentUser: '<'
            },
            controller: (MainNavController as any),
            templateUrl: '/app/src/layout/main-nav.html'
        });
}